import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Row, Col, Card, Button, Spinner } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const OMRSheetPage = () => {
  const { testId,testcode } = useParams(); // Get testId from URL params
  const [omrSheetImage, setOmrSheetImage] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    // Fetch the OMR sheet image from the API
    const fetchOMRSheetImage = async () => {
      try {
        const rollNo = localStorage.getItem("rollno");
        if (!rollNo) {
          throw new Error("Roll number is missing in localStorage.");
        }
       
        const response = await fetch(
          `https://testresult.omegacareerinstitute.com/admin/welcome/get_omrsheet/${testId}/${rollNo}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          const errorMessage = `Error ${response.status}: ${response.statusText}`;
          console.error(errorMessage);
          throw new Error(errorMessage);
        }

        const data = await response.json();
        console.log("API Response:", data);

        if (!data.imageUrl) {
          throw new Error("Invalid response: 'imageUrl' is missing.");
        }

        setOmrSheetImage(data.imageUrl);
      } catch (err) {
        console.error("Fetch Error:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchOMRSheetImage();
  }, [testId]);

  const handleDownload = () => {
    if (omrSheetImage) {
      const link = document.createElement("a");
      link.href = omrSheetImage;
      link.download = `OMR_Sheet_Test_${testId}.jpg`;
      link.click();
    }
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={8}>
          <Card>
            <Card.Header>
              <h3 className="text-center">OMR Sheet Test Code ({testcode})</h3>
            </Card.Header>
            <Card.Body className="text-center">
              {loading ? (
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              ) : error ? (
                <p style={{ color: "red" }}>{error}</p>
              ) : (
                <>
                  <img
                    src={omrSheetImage}
                    alt={`OMR Sheet for Test ${testId}`}
                    className="img-fluid mb-4"
                  />
                  <p>
                    Download the OMR sheet  by clicking the
                    button below.
                  </p>
                  <Button variant="primary" onClick={handleDownload}>
                    Download OMR Sheet
                  </Button>
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default OMRSheetPage;
